import { api } from '../services/api'
import { useLocation } from 'react-router-dom'

export function useGeolocation() {
	const location = useLocation()

	const route = location.pathname

	const defaultBody = {
		continent: 'desconhecido',
		country: 'desconhecido',
		state: 'desconhecido',
		city: 'desconhecido',
		latitude: null,
		longitude: null,
		route
	}

	async function registerPageAccess(data) {
		if (data) {
			defaultBody.data = data
		}
		await api.post('access_registration', defaultBody)

		// if (!navigator.geolocation) {
		// 	await api.post('access_registration', defaultBody)

		// 	return
		// }

		// navigator.geolocation.getCurrentPosition(
		// 	async position => {
		// 		const { latitude, longitude } = position.coords

		// 		try {
		// 			const res = await fetch(
		// 				`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=pt`
		// 			)

		// 			const response = await res.json()

		// 			const body = {
		// 				continent: response.continent || 'desconhecido',
		// 				country: response.countryName || 'desconhecido',
		// 				state: response.principalSubdivision || 'desconhecido',
		// 				city: response.city || 'desconhecido',
		// 				latitude,
		// 				longitude,
		// 				route,
		// 				data
		// 			}

		// 			await api.post('access_registration', body)
		// 		} catch(e) {
		// 			await api.post('access_registration', defaultBody)
		// 		}
		// 	}, e => {
		// 		console.log(e)
		// 	}
		// )
	}

	return { registerPageAccess }
}
